<button id="test" style="height: 20px;width: 20px;margin-bottom: 10px;font-size: 30px" type="button" class="close text-white" aria-label="Close" (click)="close()">
  <span aria-hidden="true">&times;</span>
</button>
<div class="card" style="height: 100%; width: 100%;background-color: white;z-index: 5000;overflow-y: scroll">
  <div class="card-header">Correo electrónico incorrecto</div>
  <div class="card-body">
    <div [innerHTML]="body"></div>
  </div>
</div>
